/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {
    GET_HOME_PAGE_DATA, GET_TOKEN_SUCCESS,
    SET_HOME_PAGE_TITLE
} from '../_actions/home.actions';

export const INITIAL_STATE = {
    title: 'This is Home Page',
    description: 'Home Page Discription',
    token: undefined,
    userId: undefined,
};

export function homePageReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_HOME_PAGE_DATA: {
            return {state};
        }
        case SET_HOME_PAGE_TITLE: {
            return {...state, title: action.payload};
        }
        case GET_TOKEN_SUCCESS : {
            return {
                ...state,
                token: action.payload.token
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/home.page.reducer.js